import { render, staticRenderFns } from "./TransferenciaItemsDetallexOrdenView.vue?vue&type=template&id=d7ae6e52&scoped=true&"
import script from "./TransferenciaItemsDetallexOrdenView.vue?vue&type=script&lang=js&"
export * from "./TransferenciaItemsDetallexOrdenView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ae6e52",
  null
  
)

export default component.exports